import axios from 'axios';
import store from '@/store';
import Qs from 'qs';
import { Dialog } from 'vant';
import utils from '../libs/utils';

class HttpRequest {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
    this.queue = {};
  }

  getInsideConfig() {
    return {
      baseURL: this.baseUrl,
      timeout: 10e3,
    };
  }

  destroy(url) {
    delete this.queue[url];
  }

  interceptors(instance, url) {
    // 请求拦截
    instance.interceptors.request.use(
      (config) => {
        let params = {
          urid: '',
          token: '',
          gid: 'bWV3Zzd1L2J1THc9',
          source: process.env.VUE_APP_SOURCE,
          app: process.env.VUE_APP_ID,
          apph5: process.env.VUE_APP_H5_ID,
        };
        if (store.getters.getUserInfo && store.getters.getUserInfo.token) {
					console.log('store.getters.getUserInfo', store.getters.getUserInfo)
          let { urid, token, gid } = Object.assign(
            {},
            store.getters.getUserInfo
          );
          if(!gid || gid == '') {
            gid = 'bWV3Zzd1L2J1THc9'
          }
          params = Object.assign(params, { urid, token, gid });
          // config.headers.common['Authorization'] = 'Bearer ' + store.getters.getUserInfo.token // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
        }

        switch (config.method.toUpperCase()) {
          case 'GET':
            config.params = { ...params, ...config.params };
            break;
          default:
            config.data = Qs.stringify({ ...params, ...config.data });
            config.params = { token: params.token };
            break;
        }

        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
    // 响应拦截
    instance.interceptors.response.use(
      (res) => {
        this.destroy(url);
        const { data } = res;
        let exception =
          res.config.method.toUpperCase() === 'GET'
            ? Qs.parse(res.config.params).api_throw_exception
            : Qs.parse(res.config.data).api_throw_exception;
        if (exception === false ||exception==='false') return Promise.resolve(data);
        //兼容老接口 用户授权
        if (+data.status !== 200) {
          Dialog.alert({
            title: '提示',
            message: data.message,
          });
        } else if (data.message === 'urid上传错误') {
          utils.loginConfirm();
        }
        return Promise.resolve(data);
      },
      (error) => {
        try {
          let reqdata = Qs.parse(error.config.data);
          if (reqdata.api_throw_exception === 'false')
            return Promise.resolve(error.response.data);
          let { status, message } = error.response.data;
          //授权验证
          if (status * 1 === 401) {
            utils.loginConfirm();
          } else {
            Dialog.alert({
              title: '提示',
              message: message,
            });
          }
          this.destroy(url);
          return Promise.reject(error);
        } catch (e) {
          console.log(e);
          // Dialog.alert({
          //     title: "提示",
          //     message: '请重新授权登录'
          // }).then(()=>{
          //     // wx.miniProgram.reLaunch({
          //     //     url: '/pages/user/userauth'
          //     // });
          // });
        }
      }
    );
  }

  request(options) {
    const instance = axios.create();
    options = Object.assign(this.getInsideConfig(), options);
    this.interceptors(instance, options.url);
    return instance(options);
  }
}

export default HttpRequest;
